import {
  initialState,
  Actions,
  State,
  GET_ALL_ACTIVITIES,
  GET_ALL_ACTIVITIES_SUCCESS,
  GET_ALL_ACTIVITIES_ERROR,
  RESET_GET_ALL_ACTIVITIES,
} from "../../types/activity/getAll";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_ACTIVITIES:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_ACTIVITIES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_ACTIVITIES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_ACTIVITIES:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
